import { api } from './api-client';

// GET /platform/metrics (platform-api, services/platform-metrics.service.ts)
export interface PlatformMetrics {
  tenants: { total: number; active: number; trial: number; suspended: number; cancelled: number; trialExpiringIn7Days: number };
  users: { total: number; loggedInLast30Days: number };
  vehicles: { total: number };
  missions: { active: number };
}

export const METRICS_KEY = ['platform', 'metrics'] as const;
export const METRICS_REFRESH_MS = 60_000;

export const metricsApi = {
  get: async (): Promise<PlatformMetrics> => (await api.get<PlatformMetrics>('/metrics')).data,
};
